export default "__VITE_ASSET__9385c828__"